import { ListItemNode, ListNode } from '@lexical/list';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import * as React from 'react';
import { warnAndNotify } from '../../../../Honeybadger';
import * as editorStyle from './editor.module.css';

const theme = {
  list: {
    ol: editorStyle.listOl,
    ul: editorStyle.listUl,
  },
  text: {
    strikethrough: editorStyle.textStrikethrough,
    underline: editorStyle.textUnderline,
    underlineStrikethrough: editorStyle.textUnderlineStrikethrough,
  },
};

const initialConfig = {
  namespace: 'ChatEditor',
  nodes: [ListNode, ListItemNode],
  onError: (error: Error) => warnAndNotify('ChatEditor', error.message, {}),
  theme,
};

interface Props {
  children: React.ReactNode;
}

const ChatEditorProvider: React.FC<Props> = ({ children }) => (
  <LexicalComposer initialConfig={initialConfig}>{children}</LexicalComposer>
);

export default ChatEditorProvider;
